import React, { useContext, useEffect, useReducer, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Helmet } from "react-helmet-async";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import AlertBox from "../components/AlertBox";
import CompartmentEditor from "../components/CompartmentEditor";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import useAxios from "../hooks/useAxios";
import useCompartments from "../hooks/useCompartments";
import { getError } from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "CREATE_REQUEST":
      return { ...state, loadingCreate: true };
    case "CREATE_SUCCESS":
      return {
        ...state,
        loadingCreate: false,
      };
    case "CREATE_FAIL":
      return { ...state, loadingCreate: false };

    case "DELETE_REQUEST":
      return { ...state, loadingDelete: true, successDelete: false };
    case "DELETE_SUCCESS":
      return {
        ...state,
        loadingDelete: false,
        successDelete: true,
      };
    case "DELETE_FAIL":
      return { ...state, loadingDelete: false, successDelete: false };

    case "DELETE_RESET":
      return { ...state, loadingDelete: false, successDelete: false };

    default:
      return state;
  }
};

export default function CompartmentListScreen() {
  const { dispatch: ctxDispatch } = useContext(Store);
  const axios = useAxios();
  const [
    { loading, error, loadingCreate, loadingDelete, successDelete },
    dispatch,
  ] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const navigate = useNavigate();
  const { state } = useContext(Store);
  const { userInfo, leafCategories } = state;
  const compartments = state.compartments || [];
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const [showCompartmentEditor, setShowCompartmentEditor] = useState(false);
  const [compartmentEditorOperationOk, setCompartmentEditorOperationOk] =
    useState(false);
  const [selectedCompartment, setSelectedCompartment] = useState(null);

  const [loadingCompartments, errorLoadingCompartments, setLoadComparments] =
    useCompartments();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`/api/categories/leafes/compartment`);

        ctxDispatch({
          type: "LEAF_CATEGORIES_UPDATED",
          payload: data || [],
        });
      } catch (err) {}
    };

    const leafCategories = localStorage.getItem("leafCategories")
      ? JSON.parse(localStorage.getItem("leafCategories"))
      : [];
    if (leafCategories.length === 0) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (compartmentEditorOperationOk) {
      setLoadComparments(true);
      setCompartmentEditorOperationOk(false);
    }
  }, [compartmentEditorOperationOk]);

  useEffect(() => {
    if (successDelete) {
      setLoadComparments(true);
      dispatch({
        type: "DELETE_RESET",
      });
    }
  }, [successDelete]);

  const deleteHandler = async (compartment) => {
    if (window.confirm("Silmek istediğinize emin misiniz?")) {
      try {
        dispatch({ type: "DELETE_REQUEST" });
        await axios.post("/api/compartments", [
          ...compartments.filter((c) => c._id !== compartment._id),
          {
            ...compartments.filter((c) => c._id === compartment._id)[0],
            status: false,
          },
        ]);

        dispatch({
          type: "DELETE_SUCCESS",
        });

        toast.success("Bölüm basarili bir sekilde silindi");
      } catch (err) {
        toast.error(getError(err));
        dispatch({ type: "DELETE_FAIL" });
      }
    }
  };

  return (
    <div className="small-container">
      <Helmet>
        <title>Bölümler</title>
      </Helmet>
      {!isTabletOrMobile && (
        <>
          <h1 className="my-3 text-muted">Bölümler</h1>
          <hr className="hr"></hr>
        </>
      )}
      <Row>
        <Col className="col text-end">
          <div>
            <Button
              variant="light"
              className="text-primary border-primary"
              type="button"
              onClick={() => {
                setSelectedCompartment(null);
                setShowCompartmentEditor(true);
              }}
            >
              <i className="fas fa-plus"></i>
              {!isTabletOrMobile && <>&nbsp;Bölüm Oluştur</>}
            </Button>
          </div>
        </Col>
      </Row>

      {loadingCreate && <LoadingBox></LoadingBox>}
      {loadingDelete && <LoadingBox></LoadingBox>}

      {loading || loadingCompartments ? (
        <LoadingBox></LoadingBox>
      ) : error || errorLoadingCompartments ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : compartments && compartments.length > 0 ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th></th>
                <th>Baş.No</th>
                <th>Bit.No</th>

                <th></th>
              </tr>
            </thead>
            <tbody>
              {compartments
                .filter((c) => c.status)
                .map((compartment) => (
                  <tr key={compartment._id}>
                    <td>
                      <span className="text-bold">{compartment.name}</span>
                      <div>
                        {compartment.categories.length > 0 &&
                          compartment.categories.map((c) => (
                            <div
                              key={c._id}
                              style={{ marginRight: "5px" }}
                              className="whitespacenowrap"
                            >
                              {c.name}
                            </div>
                          ))}
                      </div>
                    </td>
                    <td>{compartment.startNum}</td>
                    <td>{compartment.endNum}</td>

                    <td className="text-end" style={{ width: "35%" }}>
                      <div className="btn-group" role="group">
                        <Button
                          variant="light"
                          className={"text-success border-success "}
                          onClick={() => {
                            setSelectedCompartment(compartment);
                            setShowCompartmentEditor(true);
                          }}
                        >
                          {!isTabletOrMobile && <>Güncelle</>}{" "}
                          <i className="fa fa-edit"></i>
                        </Button>
                        &nbsp;
                        <Button
                          className={"text-danger border-danger "}
                          variant="light"
                          onClick={() => deleteHandler(compartment)}
                        >
                          {!isTabletOrMobile && <>Sil</>}{" "}
                          <i className="fas fa-trash-alt"></i>
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </>
      ) : (
        <AlertBox primary>Sisteme kayıtlı bölüm bulunamadı</AlertBox>
      )}

      <Modal
        backdrop="static"
        show={showCompartmentEditor}
        onHide={() => setShowCompartmentEditor(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {!selectedCompartment ? "Yeni Bölüm" : "Bölüm Güncelle"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CompartmentEditor
            leafCategories={leafCategories}
            setCompartmentEditorOperationOk={setCompartmentEditorOperationOk}
            setShowCompartmentEditor={setShowCompartmentEditor}
            compartments={compartments}
            selectedCompartment={selectedCompartment}
          ></CompartmentEditor>
        </Modal.Body>
      </Modal>
    </div>
  );
}
